export const shippingMethodClickAndCollectTraiteurProps = () => ({
  modeCommande: {
    type: Object,
    required: true
  },
  service: {
    type: Object,
    required: false
  },
  infosPossibleServices: {
    type: [Array, Object],
    required: true
  },
  magasinName: {
    type: String,
    required: true
  }
})

export const useShippingMethodClickAndCollectTraiteur = (props) => {
  const serviceModel = ref(null);
  const serviceSelected = (service) => {
    serviceModel.value = service;
  }
  const resetService = () => {
    serviceModel.value = null;
  }

  watch(
    () => props.service,
    (val) => { serviceModel.value = val; },
    { immediate: true }
  )

  return {
    serviceModel,
    serviceSelected,
    resetService
  }
}